import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpGrievanceHttpService {

  private dataSubject = new BehaviorSubject<any>(this.getData());
  data$ = this.dataSubject.asObservable();

  // HEADER AND SIDE BAR CHANGE CSS //

  private collapsed = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsed.asObservable();



  toggleCollapse() {
    this.collapsed.next(!this.collapsed.value);
  }

  // MAIN COMPONENT CSS WIDTH CHANGE //

  private widthSubject = new BehaviorSubject<any>('100%');
  width$ = this.widthSubject.asObservable();

  updateWidth(width: any) {
    this.widthSubject.next(width);
  }

  //CHANGE SIDE BAR MENU LIST //

  // private viewSubject = new BehaviorSubject<string>('grievance');
  private viewSubject = new BehaviorSubject<string>('');
  view$ = this.viewSubject.asObservable();

  setView(viewName: string) {
    localStorage.setItem('routeNames', viewName);
    this.viewSubject.next(viewName);
  }

  token = 'eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiJrR3JHdzhLYTBaMURVJTJCYzZXTHp1cSUyRm01ZW1MJTJGMUVjR2hzRjNiTDlEVG1UTTFTZSUyRmhFNmtJbFdiSWlzWU5WMGwiLCJ0b2tlblJlZnJlc2hLZXkiOiJXcmJsQTBzRnRCOWJMJTJGQmthc3J4dDh4YUhCa2d0NUJpWGVZNTVhRzIyYm5JN3VOa0JOYTFvekgzR0Q0TU5UM0kiLCJjYW1wdXNJZCI6MTA4LCJwYXlyb2xsSWQiOiJIWUQxMDMxMzUiLCJ1c2VyTmFtZSI6IkNIIFNBVFlBTkFSQVlBTkEiLCJ1c2VySWQiOiJIWUQxMDMxMzUiLCJ1bmlxdWVJZCI6Mjg0ODYsImp0aSI6IjY0MjEwOGM3LWYyMjUtNDU2Ni1hOGVhLTZlYWRhMWY2NWNmNSIsImlhdCI6MTc2MTU0MTg3NCwiZXhwIjoxNzYxNjI4Mjc0fQ.qdCRQGW6BI3hT0RAGcnpqdNUoAb2F3qjj8GF9UnV-nH2Ljz-53qlnqS1IaxTkiqzLiAY7X10hQF0HAohA8aGgg'
  data: any;
  constructor(private http: HttpClient) {
    const data = this.getData();
    if (data) this.dataSubject.next(data);

    window.addEventListener('storage', () => {
      const updated = this.getData();
      this.dataSubject.next(updated);
    });
  }

  getCountDetails() {
    //  this.token=localStorage.getItem('token')
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/ess/empGrievance/grievanceCount', { headers });
  }

  getGrievanceDetails() {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/ess/empGrievance/grievanceDetails', { headers });
  }

  getGrievanceStatus(uniqueRef: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/ess/empGrievance/grievanceDetailsByStatus?grievanceId=' + uniqueRef, { headers });
  }

  postGrievance(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token
    });
    return this.http.post(environment.printasseturl + '/employee/api/jwtV2/ess/empGrievance/saveTrackDetails', payload, { headers });
  }
  // getstudentDownlod(admNo: any, fileName: any): Observable<HttpResponse<Blob>>  {
  //    const headers = new HttpHeaders({
  //    'Authorization': `${this.token}`
  //   });
  //   return this.http.get(environment.printasseturl + '/employee/api/jwtV2/student/downloadGrievanceDoc?admNo=' + admNo + '&' + 'fileName=' + fileName, { headers, responseType: 'blob' },)

  // }

  getstudentDownlod(admNo: any, filename: any): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/student/downloadGrievanceDoc?admNo=' + admNo + '&' + 'fileName=' + filename, {
      headers,
      responseType: 'blob',
      observe: 'response'
    });
  }

  getEmployeeDetails(emp: any, campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/employee/currentEmployeeSearchByKeys?searchCriteria=' + emp + '&campusId=' + campusid, { headers });
  }

  setData(data: any) {
    this.dataSubject.next(data);
    localStorage.setItem('employeegrievanceData', JSON.stringify(data));
  }
  getData() {
    const stored = localStorage.getItem('employeegrievanceData');
    return stored ? JSON.parse(stored) : null;
  }

  getGrievanceReport(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/ess/empGrievance/grievanceReport?payrollId=' + payrollId, { headers });
  }

  getRolemanagement(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/employee/api/jwtV2/common/userRoles?payrollId=' + payrollId, { headers });
  }

  getEmpStates() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/employeeStates', { headers });
  }



  getStateZones(stateId:any){
  const headers = new HttpHeaders({
    'Authorization': `${this.token}`
  });
  return this.http.get(environment.printasseturl + '/apiV2/common/userStateZones?stateId='+stateId, { headers });
}

 getZoneCities(zone:any){
  const headers = new HttpHeaders({
    'Authorization': `${this.token}`
  });
  return this.http.get(environment.printasseturl + '/apiV2/common/userZoneCities?zone='+zone, { headers });
}

 getCityCampuses(city:any){
  const headers = new HttpHeaders({
    'Authorization': `${this.token}`
  });
  return this.http.get(environment.printasseturl + '/apiV2/common/empCityCampuses?cityId='+ city, { headers });
}

}
